import script from "./AdvertisingRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdvertisingRow.vue?vue&type=script&lang=ts&setup=true"

import "./AdvertisingRow.vue?vue&type=style&index=0&id=5ff3c1be&lang=scss"

const __exports__ = script;

export default __exports__